if (!customElements.get('tlv-customer-reviews')) {
  customElements.define('tlv-customer-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.list = this.querySelector('[data-review-list]');
      this.rows = [...this.list.children];
      this.visibleCount = 6;
      this.more = this.querySelector('[data-review-more]');
      this.querySelector('[data-review-sort]').addEventListener('change', event => {
        const mode = event.target.value;
        this.rows.sort((a, b) => mode === 'name' ? a.dataset.reviewName.localeCompare(b.dataset.reviewName) : mode === 'highest' ? Number(b.dataset.reviewRating) - Number(a.dataset.reviewRating) : mode === 'lowest' ? Number(a.dataset.reviewRating) - Number(b.dataset.reviewRating) : Number(a.dataset.reviewOrder) - Number(b.dataset.reviewOrder));
        this.rows.forEach(row => this.list.append(row));
        this.visibleCount = 6;
        this.update();
      });
      this.more.addEventListener('click', () => {
        const nextRow = this.rows[this.visibleCount];
        this.visibleCount += 6;
        this.update();
        if (nextRow) { nextRow.tabIndex = -1; nextRow.focus({preventScroll: true}); }
      });
      this.update();
    }
    update() {
      this.rows.forEach((row, index) => { row.hidden = index >= this.visibleCount; });
      this.more.hidden = this.visibleCount >= this.rows.length;
    }
  });
}
